export const RATING_EXTERNAL_LINKS = [
  'https://reviews.capterra.com/new/181224',
  'https://www.g2.com/products/assembly-employee-recognition-platform/reviews/start',
];
